import { render, staticRenderFns } from "./ServiceLeftSidebar.vue?vue&type=template&id=36501e13"
import script from "./ServiceLeftSidebar.vue?vue&type=script&lang=js"
export * from "./ServiceLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports